// Shared name normalization helpers for intake and registration.

const capitalizeChunk = (chunk: string) =>
  chunk.length === 0 ? chunk : chunk.charAt(0).toUpperCase() + chunk.slice(1).toLowerCase();

/** Normalizes a personal name: Mary Jane, O'Brien, Smith-Taylor, Delgado. */
export function properName(input: string): string {
  if (!input) return "";
  const cleaned = input.trim().replace(/\s+/g, " ");
  if (!cleaned) return "";
  return cleaned
    .split(" ")
    .map((word) =>
      word
        .split("-")
        .map((part) =>
          part
            .split("'")
            .map(capitalizeChunk)
            .join("'"),
        )
        .join("-"),
    )
    .join(" ");
}

const MINOR_WORDS = new Set([
  "a",
  "an",
  "and",
  "as",
  "at",
  "but",
  "by",
  "for",
  "in",
  "of",
  "on",
  "or",
  "the",
  "to",
  "with",
]);

/** Title Case for association names. Keeps typed abbreviations, lowercases minor words. */
export function unaTitleCase(input: string): string {
  if (!input) return "";
  const cleaned = input.trim().replace(/\s+/g, " ");
  if (!cleaned) return "";
  const tokens = cleaned.split(" ");
  return tokens
    .map((token, index) => {
      const letters = token.replace(/[^A-Za-z]/g, "");
      // Abbreviation the member typed in all caps stays exactly as typed.
      if (letters.length >= 2 && token === token.toUpperCase() && /[A-Z]/.test(token)) {
        return token;
      }
      const lower = token.toLowerCase();
      const isEdge = index === 0 || index === tokens.length - 1;
      if (!isEdge && MINOR_WORDS.has(lower)) return lower;
      return lower
        .split("-")
        .map((part) => part.split("'").map(capitalizeChunk).join("'"))
        .join("-");
    })
    .join(" ");
}
